import { useEffect, useRef, useState } from "react";
import {
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
} from "@material-ui/core";
import Star from "@material-ui/icons/Star";
import Check from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import ErrorOutLine from "@material-ui/icons/ErrorOutline";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";
import { toast } from "react-toastify";

import Label from "../../../components/Label";
import EventApi from "../../../services/event";
import Btn from "../../../components/Button";
import { Content, ContainerBox } from "./styles";

import html2pdf from "html2pdf.js";
import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
import { config } from "../../../config";

import QRCode from "react-qr-code";
import { getFirstAndLastNames } from "../../../utils/Functions";

const Confirmed = (props) => {
    console.log(props);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogPrintOpen, setDialogPrintOpen] = useState(false);

    useEffect(() => {
        if (!!props.data.person) {
            console.log(props.data.person);
            props.setIsLoading(false);
        }
    }, [props.data.person]);

    const close = () => {
        props.setAlreadyConfirmed(false);
        props.setSearchType("qrcode");
        props.setIsLoading(false);
        props.close();
    };

    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const handleClose = () => {
        setDialogOpen(false);
    };
    const handleClosePrint = () => {
        setDialogPrintOpen(false);
    };

    const printDialog = (
        <>
            <Dialog onClose={handleClose} open={dialogPrintOpen}>
                <ContainerBox className="content">
                    <DialogContent>
                        <Label size="medium" color="dark" align="left" weight="700" padding="5px 0">
                            Imprimir Tag para {props?.data?.person?.name}
                        </Label>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid id="teste" item md={12} style={{ width: "100%" }}>
                                <div
                                    ref={componentRef}
                                    id="to_pdf"
                                    className="card border-0"
                                    style={{ width: "480px", height: "204px", border: "none" }}
                                >
                                    <div
                                        className="row"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                            height: "100%",
                                        }}
                                    >
                                        <div className="col-sm-5">
                                            <div className="text-center">
                                                <div
                                                    style={{
                                                        height: "auto",
                                                        margin: "0 auto",
                                                        maxWidth: 64,
                                                        width: "100%",
                                                    }}
                                                >
                                                    <QRCode
                                                        size={500}
                                                        style={{
                                                            height: "auto",
                                                            maxWidth: "200px",
                                                        }}
                                                        value={props?.data?.person?.numero}
                                                        viewBox={`0 0 256 256`}
                                                    />
                                                </div>
                                                {/* <img
                          src={`${config.QRCODE_HOST}/?size=200x200&data=${props?.data?.person?.numero}`}
                          alt={`${props?.data?.person?.id}`}
                          className="card-img-top"
                          style={{ padding: "10px 0 2px 10px" }}
                        /> */}
                                            </div>
                                        </div>
                                        <div
                                            className="col-sm-7"
                                            style={{
                                                padding: "0px 10px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-evenly",
                                                alignItems: "center",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "24px",
                                                    fontWeight: "700",
                                                    textAlign: "center",
                                                    textTransform: "capitalize",
                                                }}
                                                className="text-center name"
                                            >
                                                {getFirstAndLastNames(props?.data?.person?.name?.toLowerCase())}
                                            </div>
                                            <div
                                                className="text-center info"
                                                style={{
                                                    fontSize: "18px",
                                                    fontWeight: "500",
                                                    fontStyle: "normal",
                                                    textAlign: "justify",
                                                }}
                                            >
                                                <p
                                                    className="role"
                                                    style={{
                                                        fontWeight: "600",
                                                        textTransform: "capitalize",
                                                    }}
                                                >
                                                    {props?.data?.person?.lote}
                                                </p>
                                                {/* <p
                          className="company"
                          style={{ fontSize: "16px", fontStyle: "italic" }}
                        >
                          {props?.data?.person?.lote}
                        </p> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={handleClosePrint} color="secondary">
                            cancelar
                        </Button>
                        {/* <Button variant="contained" onClick={handlePrint} color="primary">
              Imprimir
            </Button> */}
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    );

    return (
        <>
            <Container component="main" maxWidth="xs">
                <Content
                    style={{
                        background: props.data.alreadyConfirmed ? "#EC2A5F" : "#2aec5e",
                    }}
                >
                    {printDialog}
                    <div>
                        <div>
                            {/* { props.data.alreadyConfirmed ? (
                            <div style={{display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
                                <ErrorOutLine style={{fill:"#fefefe",fontSize:100,marginBottom:'20px'}}/>
                                <div style={{fontSize:'24px',fontWeight:'bold',color:'#fefefe',marginBottom:'10px'}}>
                                    Dia Inválido para
                                </div>
                                <div style={{fontSize:'24px',fontWeight:'bold',color:'#fefefe',marginBottom:'20px'}}>
                                    {props.data.person.name}
                                </div>
                                <div>
                                    <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe',marginBottom:'10px'}}>Dias Válidos: </div>
                                    <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'5px'}}>
                                        {props.data.person.day_1 && <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe'}}>17</div>}
                                        {props.data.person.day_2 && <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe'}}>18</div>}
                                        {props.data.person.day_3 && <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe'}}>19</div>}
                                    </div>
                                </div>
                                {props.data.person.extra_people && props.data.person.extra_people.length > 0 && (
                                    <div>
                                        <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe',marginBottom:'10px'}}>Extras: {props.data.person.extra_people.length}</div>
                                        {props.data.person.extra_people.map(kid => (
                                            <div style={{fontSize:'18px',fontWeight:'bold',color:'#fefefe'}}>
                                                {kid}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div style={{display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',textAlign:'center'}}>
                                <CheckCircleOutline style={{fill:"#fefefe",fontSize:100,marginBottom:'20px'}}/>
                                <div style={{fontSize:'24px',fontWeight:'bold',color:'#fefefe',marginBottom:'20px'}}>
                                    Bem vindo(a) <br/>{props.data.person.name}
                                </div>
                                <div>
                                    <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe',marginBottom:'10px'}}>Dias Válidos: </div>
                                    <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'5px'}}>
                                        {props.data.person.day_1 && <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe'}}>17</div>}
                                        {props.data.person.day_2 && <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe'}}>18</div>}
                                        {props.data.person.day_3 && <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe'}}>19</div>}
                                    </div>
                                </div>
                                {props.data.person.extra_people && props.data.person.extra_people.length > 0 && (
                                    <div>
                                        <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe',marginBottom:'10px'}}>Extras: {props.data.person.extra_people.length}</div>
                                        {props.data.person.extra_people.map(kid => (
                                            <div style={{fontSize:'18px',fontWeight:'bold',color:'#fefefe'}}>
                                                {kid}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )
                        } */}

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    textAlign: "center",
                                }}
                            >
                                <CheckCircleOutline
                                    style={{
                                        fill: "#fefefe",
                                        fontSize: 100,
                                        marginBottom: "20px",
                                    }}
                                />
                                <div
                                    style={{
                                        fontSize: "24px",
                                        fontWeight: "bold",
                                        color: "#fefefe",
                                        marginBottom: "20px",
                                    }}
                                >
                                    Bem vindo(a) <br />
                                    {props?.data?.person?.name}
                                </div>

                                {/* {!props.isActivityControl && (
                                    <div>
                                        <Button
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            color="default"
                                            onClick={(e) => setDialogPrintOpen({ dialogPrintOpen: true })}
                                        >
                                            Imprimir Tag
                                        </Button>
                                    </div>
                                )} */}

                                {/* <div>
                                    <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe',marginBottom:'10px'}}>Dias Válidos: </div>
                                    <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'5px'}}>
                                        {props.data.person.day_1 && <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe'}}>17</div>}
                                        {props.data.person.day_2 && <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe'}}>18</div>}
                                        {props.data.person.day_3 && <div style={{fontSize:'20px',fontWeight:'bold',color:'#fefefe'}}>19</div>}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="content_button">
                            <Grid container>
                                <Button
                                    className="button"
                                    variant="contained"
                                    color="secondary"
                                    disableElevation
                                    onClick={close}
                                >
                                    <CloseIcon />
                                </Button>
                            </Grid>
                        </div>
                    </div>
                </Content>
            </Container>
        </>
    );
};

export default Confirmed;
